import { SERVICES } from "../../lib/content";
import { Reveal } from "./Reveal";

const ServiceCard = ({ s, i }) => (
  <Reveal
    as="article"
    delay={(i % 3) * 0.08}
    data-testid={`service-card-${i + 1}`}
    className="group relative overflow-hidden rounded-xl border border-cs-navy/10 bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_-24px_rgba(18,48,63,0.45)]"
  >
    {s.href && <span className="absolute left-4 top-4 z-10 rounded-full bg-cs-yellow px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-cs-navy">Nouveau</span>}
    <div className="h-56 overflow-hidden">
      <img
        src={s.img}
        alt={s.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
    </div>
    <div className="p-6 md:p-7">
      <span className="font-display text-xs font-bold tracking-[0.2em] text-cs-yellow-dark">0{i + 1}</span>
      <h3 className="mt-2 font-display text-xl font-bold tracking-tight text-cs-navy">{s.title}</h3>
      <p className="mt-2 text-[15px] leading-relaxed text-cs-ink/75">{s.text}</p>
      {s.href && <a href={s.href} className="mt-4 inline-flex text-sm font-bold text-cs-navy underline decoration-cs-yellow decoration-2 underline-offset-4" data-testid="service-card-rangement-link">Découvrir le rangement à domicile</a>}
    </div>
  </Reveal>
);

export const Services = () => (
  <section id="services" data-testid="services-section" className="scroll-mt-20 bg-white py-20 md:py-28">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal className="mb-12 max-w-2xl md:mb-16">
        <span className="eyebrow">Ce que nous faisons</span>
        <h2 className="section-title">Nos services</h2>
      </Reveal>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-7">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.title} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
